module.exports = __webpack_public_path__ + "static/img/brand-logo.e59fbca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-logo.svg
// module id = rwlq
// module chunks = 3